import {Injectable} from '@angular/core';
import {ApiClientService} from '../api-client/api-client.service';
import {ApiResponse} from '../../api/api-response';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnerMetaAdsService {
  private routePath = '/partner/meta-ads';

  constructor(
    protected apiClient: ApiClientService,
  ) {
  }

  getAccountInfos(partnerId: number): Observable<any> {
    return new Observable<any>((subscriber) => {
      this.apiClient.get(this.routePath + '/' + partnerId + '/account-infos', {}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
